<p>logout works!</p>
<ngx-spinner></ngx-spinner>